import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  getAllAttachmentUploads,
  getAllUploads,
} from '@wix/da-shared-react/pkg/redux/uploads/selectors';

export function useUploadsBeforeUnload() {
  const uploads = useSelector(getAllUploads);
  const attachmentUploads = useSelector(getAllAttachmentUploads);
  const isUploadingRef = useRef<boolean>(false);

  useEffect(() => {
    isUploadingRef.current = uploads.length > 0 || attachmentUploads.length > 0;
  }, [uploads, attachmentUploads]);

  useEffect(() => {
    window.addEventListener('beforeunload', event => {
      if (isUploadingRef.current) {
        event.preventDefault();
      }
    });
  }, []);
}
